import { Injectable, signal } from '@angular/core';
import { OperacionSocietaria } from '../mock-data/operaciones.mock';

@Injectable({ providedIn: 'root' })
export class OperationWizardService {
  private readonly _completedOperation = signal<OperacionSocietaria | null>(null);

  setResult(op: OperacionSocietaria): void {
    this._completedOperation.set(op);
  }

  consumeResult(): OperacionSocietaria | null {
    const op = this._completedOperation();
    this._completedOperation.set(null);
    return op;
  }
}
